module.exports = __webpack_public_path__ + "media/images/lp_logo-8a9c0ca9cc1a90925ae66e3ff16edb7b.webp";